<template>
  <div class="seccion404">
    <section id="servicios" class="secciones seccion-blanca">
      <div class="container">
        <h1>Error 404. Oops! Estas perdido.</h1>
        <div class="row">
          <div class="col-md-12">
            <p style="text-align: center;">La pagina que estas buscando no se encuentra.</p>
          </div>
        </div>
      </div>
    </section>
    <GoToTrackingModule />
    <MultimediaModule />
  </div>
</template>

<script>
import GoToTrackingModule from '@/modules/GoToTrackingModule.vue';
import MultimediaModule from '@/modules/MultimediaModule.vue';
import _ from 'lodash';
import { errorToaster } from '../components/shared/service/ErrorHandler';

export default {
  components: { TwoModules, MultimediaModule },
  methods: {
    scroll_inicio() {
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.scroll_inicio();
  },
};
</script>

<style lang="scss">
.seccion404 {
  padding-top: 30px;
}

@media (min-width: 992px) {
  .seccion404 {
    padding-top: 130px;
  }
}
</style>
